import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { UserContext } from '@/components/App';
import EmailSubscriptions from '@/components/Account/EmailSubscriptions';
import { AccentBar, Card, Section, SectionHeader, SectionTitle } from '../blocks';

// EmailSubscriptions already renders the category accordion with "N of M on" counts and owns
// its own mutations; it reads the shipper from the overridden context.
const CommunicationsTab = () => {
    const { client } = useContext(UserContext);

    return (
        <Section>
            <SectionHeader>
                <AccentBar />
                <SectionTitle>Communications &amp; notifications</SectionTitle>
            </SectionHeader>
            <Card>
                <div
                    css={css`
                        padding: 1.5rem;
                    `}
                >
                    <EmailSubscriptions client={client} />
                </div>
            </Card>
        </Section>
    );
};

export default CommunicationsTab;
